import { LoadState } from "../../../constants/enums";

export interface IAccountingReports {
  sales_commission_summary: {
    list: ISalesCommissionSummary[];
    loading: LoadState;
  };
  sales_commission_detailed: {
    list: ISalesCommissionDetailed[];
    loading: LoadState;
  };
  sales_commission_detailed_breakdown: {
    list: ISalesCommissionDetailedBreakdown[];
    loading: LoadState;
  };
  sales_commission_summary_by_type: {
    list: ISalesCommissionSummaryByType[];
    loading: LoadState;
  };
  receivable_summary: {
    list: IAccountReceivableReport[];
    loading: LoadState;
  };
  receivable_detailed: {
    list: IAccountReceivableDetailed[];
    loading: LoadState;
  };
  tax: {
    list: IAccoutingTaxStatement[];
    loading: LoadState;
  };
  account_payable: {
    list: IAccountingAccountPayableReport[];
    loading: LoadState;
  };
  insurance_remittance: {
    list: IInsuranceRemittance[];
    loading: LoadState;
  };
  aged_insurer_payables: {
    list: IAgedInsurerPayables[];
    loading: LoadState;
  };
}

export interface IAgedInsurerPayables {
  insurer_code: string;
  name: string;
  line_of_business: string;
  producer_code: string;
  policy_number: string;
  policy_effective_date: string;
  branch: string;
  pre_billed: string;
  transaction_type: string;
  transaction_date: string;
  zero_to_thirty_days: string;
  thirty_one_to_sixty_days: string;
  sixty_one_to_ninety_days: string;
  over_ninety_days: string;
  sum_total_amount: string;
}
export interface IInsuranceRemittance {
  insurer_code: string;
  accn_invoice_transaction_items_id: number;
  name: string;
  code: string;
  policy_number: string;
  policy_type: string;
  transaction_type: string;
  branch_code: string;
  producer_one_code: string;
  transaction_effective_date: string;
  amount: string;
  commission_percentage: string;
  commission_amount: string;
  net_payable_insurer: string;
  company_paid: string;
  company_paid_date: string;
  transaction_date: string;
}

export interface IAccountingAccountPayableReport {
  accn_bill_transaction_items_id: string | null;
  vendor_type: string | null;
  transaction_date: string | null;
  name: string | null;
  policy_number: string | null;
  effective_date: string | null;
  branch_code: string | null;
  producer_one_code: string | null;
  policy_type: string | null;
  insurer_code: string | null;
  amount: string | null;
  commission_percentage: string | null;
  commission_amount: string | null;
  current_amount_due: string | null;
  amount_paid: string | null;
  net_payable_to_insurer: string | null;
  producer_commission: string | null;
  branch_commission: string | null;
  amount_payable: string | null;
  running_balance: string | null;
  insert_ts: string | null;
}

export interface IAccoutingTaxStatement {
  accn_invoice_transaction_items_id: string;
  invoice_for: string;
  agency_or_direct_bill: string;
  invoice_number: string;
  transaction_date: string;
  name: string;
  policy_number: string;
  policy_type: string;
  branch_code: string;
  insurer_code: string;
  producer_one_code: string;
  transaction_type: string;
  amount: string;
  default_tax_region: string;
  tax_one_percentage: string;
  tax_one_amount: string;
  tax_two_percentage: string;
  tax_two_amount: string;
}
export interface IAccountReceivableReport {
  accn_invoice_transaction_items_id: number;
  invoice_for: string;
  agency_or_direct_bill: string;
  name: string;
  code: string;
  policy_number: string;
  branch_code: string;
  producer_one_code: string;
  transaction_date: string;
  current_amount_due: string;
  pre_billed: string;
  zero_to_thirty_days: string;
  thirty_one_to_sixty_days: string;
  sixty_one_to_ninety_days: string;
  over_ninety_days: string;
  running_balance: number;
  insert_ts: string;
  financed_by: string;
  premium_financed: string;
  post_dated: string;
}

export interface IAccountReceivableDetailed {
  invoice_id: number;
  accn_invoice_payment_transaction_items_id: number;
  invoice_number: string;
  invoice_date: string | null;
  payment_number: string;
  entry_type: string;
  gl_accounts: string;
  invoice_payment_gl_account_name: string;
  date: string;
  batch_number: string | null;
  reciept_number: string | null;
  payment_for: string;
  name: string;
  code: string | null;
  policy_number: string;
  payment_type: string;
  payment_currency: string;
  payment_amount: string;
  service_fee: string | null;
  payment_method: string;
  bank: string;
  net_payable: string | null;
  total_due_dollar: string;
  amount_due: string;
  payment_paid: string | null;
  payment_id: number | null;
  total_paid: string | null;
  is_partial_payment: number;
  status: string;
  created_by_id: number;
  modified_by_id: number;
  actual_amount_due: string | null;
  invoice_due_date: string;
  transaction_type: string;
  gl_account_code: string;
  amount: string;
  payment_terms: string;
  policy_type: string;
  policy_transaction_type: string;
  policy_status: string;
  effective_date: string;
  default_tax_region: string;
  agency_or_direct_bill: string;
  premium_financed: string;
  financed_by: string;
  financed_fee: string | null;
  producer_one_id: number;
  producer_one_code: string;
  producer_two_id: number;
  producer_two_code: string;
  producer_three_id: number;
  producer_three_code: string;
  csr_code: string | null;
  branch_code: string | null;
  insurer_code: string;
  tax_one_percentage: string;
  tax_one_amount: string;
  tax_two_percentage: string;
  tax_two_amount: string;
  commission_percentage: string;
  commission_amount: string;
  house_percentage: string;
  house_amount: string;
  producer_one_percentage: string;
  producer_one_amount: string;
  producer_two_percentage: string;
  producer_two_amount: string;
  producer_three_percentage: string;
  producer_three_amount: string;
  branch_percentage: string;
  branch_amount: string;
  total_amount: string;
  zero_to_thirty_days: string;
  thirty_one_to_sixty_days: string;
  sixty_one_to_ninety_days: string;
  over_ninety_days: string | null;
  insert_ts: string;
}

export interface ISalesCommissionSummary {
  month: string | null;
  agency_or_direct_bill: string | null;
  total_premium: string | null;
  total_branch_amount: string | null;
  total_producer_one_amount: string | null;
  total_producer_two_amount: string | null;
  total_producer_three_amount: string | null;
  total_commission_amount: string | null;
  total_net_payable_insurer: string | null;
  total_tax_one_amount: string | null;
  total_tax_two_amount: string | null;
}

export interface ISalesCommissionSummaryByType {
  month: string | null;
  agency_or_direct_bill: string | null;
  total_premium: string | null;
  total_branch_amount: string | null;
  total_producer_one_amount: string | null;
  total_producer_two_amount: string | null;
  total_producer_three_amount: string | null;
  total_commission_amount: string | null;
  total_net_payable_insurer: string | null;
  total_tax_one_amount: string | null;
  total_tax_two_amount: string | null;
}

export interface ISalesCommissionDetailed {
  [key: string]: any;
}
export interface ISalesCommissionDetailedBreakdown {
  [key: string]: any;
}

export const initialCalAgencyBillorDirectBillState: IAccountingReports = {
  sales_commission_summary: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  sales_commission_detailed: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  sales_commission_detailed_breakdown: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  sales_commission_summary_by_type: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  receivable_summary: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  receivable_detailed: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  tax: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  account_payable: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  insurance_remittance: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  aged_insurer_payables: {
    list: [],
    loading: LoadState.NotLoaded,
  },
};
